import { createContext } from 'react'

const FolderContext = createContext({
  id: null,
  path: null,
  item: null,
  returnToId: null,
  set: ({ id, path, item }) => {},
})
export default FolderContext

